/** 勤務 (shift_truck) ごとの行表示。1 台に複数のドライバーが同じ時間帯で乗る勤務で使う */
export type ShiftTruckRowInfo = {
  shiftStart: string | null;
  shiftEnd: string | null;
  workingAvailableSeconds: number | null;
  /** shift_trucks.truck_number。空なら車両単位の優先順位 (leg_run → マスタ) に落とす */
  plateNumber: string | null;
};

/** 勤務の解決に必要な最小の delivery 情報。id は shift_truck.id */
export type ShiftTruckRowSource = {
  id: number;
  startAt?: string | null;
  endAt?: string | null;
  workingAvailableDurationSeconds?: number | null;
  truckNumber?: string | null;
};

/** ISO 日時文字列を "HH:mm" に整形する。パース不能・未指定は null */
export function formatHourMinute(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

/**
 * delivery (= shift_truck) の配列を shift_truck.id 引きのマップにする。
 *
 * 車両単位のマップ (buildVehicleExtraMap) は truckId ごとに先頭 delivery だけを代表値に
 * するので、1 台に複数のドライバーが乗る勤務では全行が 1 人目の値になってしまう。
 */
export function buildShiftTruckRowInfoMap(
  deliveries: readonly ShiftTruckRowSource[],
): Map<number, ShiftTruckRowInfo> {
  const map = new Map<number, ShiftTruckRowInfo>();
  for (const d of deliveries) {
    map.set(d.id, {
      shiftStart: formatHourMinute(d.startAt),
      shiftEnd: formatHourMinute(d.endAt),
      workingAvailableSeconds: d.workingAvailableDurationSeconds ?? null,
      plateNumber: d.truckNumber ?? null,
    });
  }
  return map;
}

/** VehicleInfoView へ渡す行単位の上書き。キーが無いものは車両単位の表示のまま */
export type VehicleRowOverride = {
  driverShift?: { start: string; end: string; workingAvailableSeconds: number | null } | null;
  plateNumber?: string;
};

export function resolveRowVehicleOverride(info: ShiftTruckRowInfo | undefined): VehicleRowOverride {
  if (!info) return {};
  const override: VehicleRowOverride = {
    driverShift: info.shiftStart && info.shiftEnd
      ? { start: info.shiftStart, end: info.shiftEnd, workingAvailableSeconds: info.workingAvailableSeconds }
      : null,
  };
  if (info.plateNumber != null && info.plateNumber.trim().length > 0) {
    override.plateNumber = info.plateNumber;
  }
  return override;
}
